exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-order-info[data-v-3b0ad7b2],.delivery-orderproduct-table[data-v-3b0ad7b2]{width:100%}.delivery-orderproduct-table th[data-v-3b0ad7b2]{background-color:#eee}.delivery-order-info td[data-v-3b0ad7b2],.delivery-orderproduct-table td[data-v-3b0ad7b2],.delivery-orderproduct-table th[data-v-3b0ad7b2]{text-align:center!important;border:1px solid #e0d9d9;padding:6px;vertical-align:middle!important}.delivery-orderproduct-table .table-result[data-v-3b0ad7b2]{background-color:#ebeae4}.delivery-order-info .order-info-title[data-v-3b0ad7b2],.order-info-title[data-v-3b0ad7b2]{background-color:#eee}", ""]);

// exports
